export const DEFAULT_STATE = {
    voiceId: '',
    rate: 1,
};
